import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface DashboardClinicShortcutsProps {
  tenantId: string;
  period: string;
}

/** Atajos a dominios del hub de la única clínica (con periodo sticky). */
export function DashboardClinicShortcuts({ tenantId, period }: DashboardClinicShortcutsProps) {
  const { t } = useTranslation();
  const base = `/clinics/${encodeURIComponent(tenantId)}?period=${encodeURIComponent(period)}`;

  const items = [
    { to: `${base}&tab=finances`, labelKey: 'dashboard.command.shortcuts.finances' },
    { to: `${base}&tab=patients`, labelKey: 'dashboard.command.shortcuts.patients' },
    { to: `${base}&tab=professionals`, labelKey: 'dashboard.command.shortcuts.professionals' },
  ] as const;

  return (
    <section aria-label={t('dashboard.command.shortcuts.ariaLabel')} className="space-y-2">
      <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-500 dark:text-slate-400">
        {t('dashboard.command.shortcuts.title')}
      </h2>
      <div className="flex flex-wrap gap-2">
        {items.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="inline-flex items-center rounded-xl border border-slate-200/90 bg-white/90 px-3 py-2 text-sm font-semibold text-teal-800 transition hover:border-teal-300 hover:bg-teal-50 dark:border-gray-700 dark:bg-gray-900/80 dark:text-teal-200 dark:hover:border-teal-700 dark:hover:bg-teal-950/40"
          >
            {t(item.labelKey)}
          </Link>
        ))}
      </div>
    </section>
  );
}
